import { CONTACT_COMMENT, DEFAULT_SUBSTATE } from './invoices-my-international.constants';
import { EIIState } from '@shared';

export function getSubStateComment(state: EIIState, subState: string): string {
  const hasSubState = subState && subState !== DEFAULT_SUBSTATE;

  if (!hasSubState) {
    return state === EIIState.NOT_VERIFIED ? CONTACT_COMMENT : '';
  }

  return subState;
}
